import React from 'react';

const DsraDipDetailsDialogUI = ({ isOpen, onClose, details }) => {
  if (!details || !details.length) return null;

  const formatDate = (dateStr) => {
    if (!dateStr || dateStr === 'N/A') return 'N/A';
    const [year, month, day] = dateStr.split('-');
    return `${day}-${month}-${year}`;
  };

  const parseAmount = (str) => {
    const clean = str.replace(/,/g, '');
    const num = Number(clean);
    return isNaN(num) ? 0 : num;
  };

  const parseDetail = (detail) => {
    const parts = detail.split(',');
    if (parts.length < 5) return null;

    // Get last two parts
    const status = parts[parts.length - 1];
    const date = parts[parts.length - 2];

    // Remaining parts make up: total, current, dip (all may have commas)
    const remaining = parts.slice(0, parts.length - 2);
    const total = remaining.slice(0, 3).join(',');
    const current = remaining.slice(3, 6).join(',');
    const dip = remaining.slice(6).join(',');

    return { total, current, dip, date, status };
  };

  let totalTotal = 0;
  let totalCurrent = 0;
  let totalDip = 0;

  return (
    <div className="popup" style={isOpen ? { display: 'flex' } : { display: 'none' }}>
      <div
        className="popup-inner"
        style={{
          maxWidth: '95vw',
          width: '800px',
          overflowX: 'auto',
          paddingBottom: '1rem',
        }}
      >
        <div className="g_flex_h" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
          <h2>DSRA DIP Details</h2>
          <button
            style={{ border: 'none', background: 'none', fontSize: '24px', cursor: 'pointer' }}
            onClick={onClose}
          >
            &times;
          </button>
        </div>

        <div style={{ overflowX: 'auto' }}>
          <table className="popup-table" style={{ minWidth: '800px' }}>
            <thead>
              <tr>
                <th>DSRA Total</th>
                <th>DSRA Current</th>
                <th>DSRA DIP</th>
                <th>Date</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {details.map((detail, index) => {
                const parsed = parseDetail(detail);
                if (!parsed) return null;

                const { total, current, dip, date, status } = parsed;

                const totalVal = parseAmount(total);
                const currentVal = parseAmount(current);
                const dipVal = parseAmount(dip);

                totalTotal += totalVal;
                totalCurrent += currentVal;
                totalDip += dipVal;

                const statusStyle = {
                  color: status === 'Dipped' ? 'red' : status === 'Restored' ? 'green' : 'inherit',
                  fontWeight: 'bold',
                };

                return (
                  <tr key={index}>
                    <td>{total}</td>
                    <td>{current}</td>
                    <td>{dip}</td>
                    <td>{formatDate(date)}</td>
                    <td style={statusStyle}>{status}</td>
                  </tr>
                );
              })}
            </tbody>
            {/* <tfoot>
              <tr style={{ fontWeight: 'bold' }}>
                <td>{totalTotal.toLocaleString()}</td>
                <td>{totalCurrent.toLocaleString()}</td>
                <td>{totalDip.toLocaleString()}</td>
                <td colSpan={2}>Total</td>
              </tr>
            </tfoot> */}
          </table>
        </div>
      </div>
    </div>
  );
};

export default DsraDipDetailsDialogUI;
